import React, { useMemo } from 'react';
import useNavigateWithSearch from '../../../../hooks/useNavigateWithSearch';
import LoadingBar from '../../global/LoadingBar';
import PaymentMethod from './PaymentMethod/PaymentMethod';
import PageContent from '../../global/PageContent';
import { ROUTE_MY_ACCOUNT, ROUTE_MEMBERSHIP_CANCEL } from '../../config/routes';
import MembershipHeaderWithStatus from './MembershipHeaderWithStatus';
import useSubscriptionStatus from '../../../../hooks/useSubscriptionStatus';
import { BUTTON_TYPE, BUTTON_SIZE, Button } from '../../global/Button';

import './ManageMembership.scss';

const ManageMembership = () => {
  const {
    subscriptionStatus,
    isLoading,
    hasError,
    getMembershipSubscriptionData,
    membershipSubscriptionData,
  } = useSubscriptionStatus();
  const navigateWithSearch = useNavigateWithSearch();
  const headerComponent = useMemo(() => (
    <div className="ManageMembership__container--header">
      <MembershipHeaderWithStatus subscriptionStatus={subscriptionStatus} />
      <div className="ManageMembership__container--header-renew">
        {subscriptionStatus.message}
      </div>
    </div>
  ), [subscriptionStatus]);

  const renderContent = () => {
    if (isLoading) {
      return <LoadingBar />;
    }

    if (hasError) {
      return (
        <div className="ManageMembership__error">
          <div className="ManageMembership__error--message">
            Unable to load membership information
          </div>
          <button
            type="button"
            className="ManageMembership__error--retry"
            onClick={getMembershipSubscriptionData}
          >
            Try Again
          </button>
        </div>
      );
    }

    return (

      <div className="ManageMembership__container">
        {headerComponent}

        <div className="ManageMembership__container--manage-membership">
          <PaymentMethod paymentDetails={membershipSubscriptionData?.paymentDetails} />
        </div>
        <div className="ManageMembership__container--manage-membership--actions">
          <div className="ManageMembership__container--manage-membership--actions--title">Manage Membership</div>
          <div className="ManageMembership__container--manage-membership--actions--content">
            <Button
              type={BUTTON_TYPE.LINK_QUATERNARY}
              size={BUTTON_SIZE.SMALL}
              className="ManageMembership__container--manage-membership--actions--content-link"
              onClick={() => navigateWithSearch(ROUTE_MEMBERSHIP_CANCEL)}
              disabled={membershipSubscriptionData?.cancelAtPeriodEnd}
            >
              Cancel Auto-Renewal
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <PageContent
      className="ManageMembership"
      headerClassName="ManageMembership__header"
      backButtonText="GO TO MY ACCOUNT"
      parentUrl={ROUTE_MY_ACCOUNT}
    >
      {renderContent()}
    </PageContent>
  );
};

export default ManageMembership;
